export default "__VITE_ASSET__d8a75e2a__"